import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMobile } from '@/shared/hooks';
import { Drawer } from 'antd';
import { useState } from 'react';
import { Dragging } from './Dragging';
import { Menu } from './Menu';
import styles from './sider.module.less';
import open_menu_img from '@/shared/assets/png/menu-open.png';
export const Sider = (props) => {
    const [collapsed, setCollapsed] = useState(false);
    const [open, setOpen] = useState(true);
    const isMobile = useMobile();
    if (isMobile) {
        return (_jsxs(_Fragment, { children: [_jsx(Drawer, { className: styles.menuDrawer, contentWrapperStyle: { width: '200px' }, placement: 'left', closable: false, onClose: () => {
                        setOpen(false);
                    }, open: open, children: _jsx(Menu, { collapsed: collapsed }) }), _jsx("img", { onClick: () => { setOpen(true); }, className: styles['lj-open-menu-img'], src: open_menu_img, width: 40, height: 40 })] }));
    }
    return (_jsx(Dragging, { ...props, collapsed: collapsed, setCollapsed: setCollapsed, children: _jsx(Menu, { collapsed: collapsed }) }));
};
